import { PropertyWidget, Widget } from './widget';

export abstract class IntegerWidget<T extends Widget = Widget>
extends PropertyWidget<T> { }
